var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-group"},_vm._l((_vm.actuators),function(actuator){return _c('app-actuators',{key:actuator.name,attrs:{"actuator":actuator},on:{"setActuator":_vm.setActuator}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }